module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1063.fd3fb7f2.png";